import _get from "lodash/get";
export var getVisitorProfileByType = function getVisitorProfileByType(state, profileType) {
  return _get(state, "identity.visitorData.profiles.".concat(profileType));
};
export var getIsUpdatingVisitorProfile = function getIsUpdatingVisitorProfile(state) {
  return _get(state, 'identity.visitorData.requests.updateVisitorProfile.hasPendingRequests');
};
export var getIsRequestingVisitorProfile = function getIsRequestingVisitorProfile(state) {
  return _get(state, 'identity.visitorData.requests.readVisitorProfile.hasPendingRequests');
};
export var getVisitorProductShoppingActions = function getVisitorProductShoppingActions(state) {
  return _get(state, 'identity.visitorData.productShoppingActions');
};
export var getIsRequestingVisitorProductShoppingActions = function getIsRequestingVisitorProductShoppingActions(state) {
  return _get(state, 'identity.visitorData.requests.readVisitorProductShoppingActions.hasPendingRequests');
};